export default {
  chip: {
    '& .MuiChip-label': {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      padding: 0,
      marginLeft: '.45rem'
    },
    padding: '4px 6px 4px 4px',
    margin: '1em 0 .5em 0'
  },
  bottomStickyWrapper: {
    width: '100%',
    position: 'sticky',
    bottom: 0,
    p: '1.1rem 0.8rem',
    display: 'flex',
    flexFlow: 'column',
    rowGap: '1.5rem',
    borderTop: '1px solid',
    borderColor: 'border.lighter',
    zIndex: 10,
    backgroundColor: 'bg.white'
  }
};
